module.exports = __webpack_public_path__ + "a70df42b1a0bfb9b954c9deb89e7a43c.png";